import { motion } from "framer-motion";
import { Check, X } from "lucide-react";
import { NEED_YES, NEED_NO } from "@/data/content";

export default function NeedCheck() {
  return (
    <section id="need-check" className="relative py-20 md:py-28 bg-[#0A0A0F]" data-testid="need-check-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="font-serif text-white text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight max-w-3xl"
        >
          The dealer works for the dealer. <span className="italic gradient-text">We negotiate for you.</span>
        </motion.h2>

        <div className="mt-10 flex flex-wrap items-center gap-4 md:gap-6" data-testid="need-check-roles">
          <div className="rounded-2xl border border-white/10 bg-surface px-6 py-4">
            <p className="text-xs uppercase tracking-[0.2em] text-silver/50">Dealer</p>
            <p className="mt-1 font-serif text-xl text-white">→ Salesperson</p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-surface px-6 py-4 gradient-border">
            <p className="text-xs uppercase tracking-[0.2em] text-silver/50">Buyer (you)</p>
            <p className="mt-1 font-serif text-xl text-white">→ Your Saarthi</p>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="rounded-3xl border border-white/5 bg-surface p-7 md:p-8"
            data-testid="need-check-yes"
          >
            <p className="eyebrow gradient-text">You probably need a Saarthi if</p>
            <ul className="mt-5 space-y-3">
              {NEED_YES.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm md:text-base text-silver/80">
                  <Check className="w-4 h-4 mt-1 shrink-0 text-[#4FC3F7]" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="rounded-3xl border border-white/5 bg-surface p-7 md:p-8"
            data-testid="need-check-no"
          >
            <p className="eyebrow text-silver/50">You're probably fine without us if</p>
            <ul className="mt-5 space-y-3">
              {NEED_NO.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm md:text-base text-silver/60">
                  <X className="w-4 h-4 mt-1 shrink-0 text-silver/40" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <p className="mt-8 text-sm text-silver/45 max-w-2xl">
          We'd rather tell you that you don't need us than sell you something you don't.
        </p>
      </div>
    </section>
  );
}
